module.exports = __webpack_public_path__ + "static/media/4.83ac95be.jpg";